import { render, staticRenderFns } from "./FeedOffers.vue?vue&type=template&id=5237f086&scoped=true&"
import script from "./FeedOffers.vue?vue&type=script&lang=ts&"
export * from "./FeedOffers.vue?vue&type=script&lang=ts&"
import style0 from "./FeedOffers.scss?vue&type=style&index=0&id=5237f086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237f086",
  null
  
)

export default component.exports